import { render, staticRenderFns } from "./WarningsPanel.vue?vue&type=template&id=37182840&"
import script from "./WarningsPanel.vue?vue&type=script&lang=js&"
export * from "./WarningsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports